/** @format */

// import { getServiceInfo, getAgreement } from '@/services/api'
import store from '@/store'

const service = {
  state: () => ({
    websocket: null,
    transcriptTimeout: null,
    summaryTimeout: null,
    transcriptInfo: null,
    summaryInfo: null,
    parsingDataList: [],

    // 릴리즈 시점으로 변경 예정
    // 기준시 이전 클립은 Transcript, Summary 정보 호출하지 않고 Front 탭도 비활성화 시켜준다.
    baseTimeStamp: 1682866800000,
  }),
  mutations: {
    // ApiGateway Web Socket
    setWebsocket(state, websocket) {
      state.websocket = websocket
    },
    // 5초마다 Transcript 호출하는 timeout
    setTranscriptTimeout(state, transcriptTimeout) {
      state.transcriptTimeout = transcriptTimeout
    },
    // 5초마다 Summary 호출하는 timeout
    setSummaryTimeout(state, summaryTimeout) {
      state.summaryTimeout = summaryTimeout
    },
    // Transcript 정보
    setTranscriptInfo(state, transcriptInfo) {
      state.transcriptInfo = transcriptInfo
    },
    // Summary 정보
    setSummaryInfo(state, summaryInfo) {
      state.summaryInfo = summaryInfo
    },
    setParsingDataList(state, parsingDataList) {
      state.parsingDataList = parsingDataList
    },
  },
  actions: {
    /**
     * Websocket 연결
     */
    //   { state, commit, dispatch }
    setSummaryInfo({ commit }, summaryInfo) {
      commit('setSummaryInfo', summaryInfo)
    },

    setSummaryTimeout({ commit }, summaryTimeout) {
      commit('setSummaryTimeout', summaryTimeout)
    },

    setTranscriptInfo({ commit }, transcriptInfo) {
      commit('setTranscriptInfo', transcriptInfo)
    },

    setTranscriptTimeout({ commit }, transcriptTimeout) {
      commit('setTranscriptTimeout', transcriptTimeout)
    },
    setParsingDataList({ commit }, parsingDataList) {
      commit('setParsingDataList', parsingDataList)
    },

    async connectWebsocket({ state, commit, dispatch }, message) {
      const websocket = new WebSocket(process.env.VUE_APP_WEB_SOCKET_END_POINT_URL)
      commit('setWebsocket', websocket)

      websocket.onopen = () => {
        websocket.onmessage = ({ data }) => {
          let parsedData
          let key
          try {
            let result = data && typeof data === 'string' ? JSON.parse(data) : null
            parsedData = result['message'] ?? null
            key = result['key'] ?? null

            // websocket 용량 제한으로 나누어 보낼경우에는 string 으로 보내준다.
            if (parsedData && typeof parsedData === 'string') {
              let parsingList = state['parsingDataList']
              if (parsingList && parsingList.length > 0) {
                let index = parsingList.findIndex((value) => value['key'] === key)
                if (index > -1) parsingList[index]['data'] += parsedData

                try {
                  let temp = JSON.parse(parsingList[index]['data'])
                  parsedData = temp
                  parsingList.splice(index, 1)
                  commit('setParsingDataList', parsingList)
                } catch (error) {
                  // Parsing 이 되지 않았다면 컨텐츠 더해준 부분을 세팅해준다.
                  commit('setParsingDataList', parsingList)
                }
              } else if (parsedData.includes('body')) {
                try {
                  let temp = JSON.parse(parsedData)
                  parsedData = temp
                } catch (error) {
                  parsingList.push({
                    key: key,
                    data: parsedData,
                  })
                  commit('setParsingDataList', parsingList)
                }
              }
            }
          } catch (error) {
            console.log('parsing error ', error)
          }
          if (parsedData && (parsedData['statusCode'] === 200 || parsedData['statusCode'] === '200')) {
            let currentClip = store.getters.currentClip
            if (parsedData['transcriptStatus']) currentClip['transcriptStatus'] = parsedData['transcriptStatus']
            if (parsedData['summaryStatus']) currentClip['summaryStatus'] = parsedData['summaryStatus']
            store.dispatch('setCurrentClip', currentClip)
            // console.log('socket call ', parsedData)

            switch (parsedData['type']) {
              /**
               * Transcript 호출 결과 처리
               */
              case 'transcript':
                // console.log('socket transcript ')
                // 데이터가 존재하고, 현재 ClipId 와 요청했던 ClipId 가 같다면 데이터 세팅
                if (
                  store.getters.currentClip &&
                  parsedData['body'] &&
                  store.getters.currentClip['clipId'] === parsedData['clipId']
                ) {
                  commit('setTranscriptInfo', parsedData['body'])
                }
                // 현재 ClipId 와 요청했던 ClipId 가 같지만, transcriptInfo 정보가 없다면 재호출
                else if (
                  store.getters.currentClip &&
                  store.getters.currentClip['clipId'] === parsedData['clipId'] &&
                  (!parsedData['body'] || !parsedData['body']['tsSegments']) &&
                  store.getters.currentClip['transcriptStatus'] !== 2
                ) {
                  // 5초에 한번씩 Transcript 완료 되었나 확인
                  const transcriptTimeout = setTimeout(() => {
                    dispatch('getTranscriptInfo', false)
                  }, 5000)

                  commit('setTranscriptTimeout', transcriptTimeout)
                }
                break
              /**
               * Summary 호출 결과 처리
               */
              case 'summary':
                // console.log('socket summary ')
                // 데이터가 존재하고, 현재 ClipId 와 요청했던 ClipId 가 같다면 데이터 세팅
                if (
                  store.getters.currentClip &&
                  parsedData['body'] &&
                  store.getters.currentClip['clipId'] === parsedData['clipId']
                ) {
                  commit('setSummaryInfo', parsedData['body'])
                }
                // 현재 ClipId 와 요청했던 ClipId 가 같지만, Summary 정보가 없다면 재호출
                else if (
                  store.getters.currentClip &&
                  store.getters.currentClip['clipId'] === parsedData['clipId'] &&
                  !parsedData['body'] &&
                  store.getters.currentClip['summaryStatus'] !== 2
                ) {
                  // 5초에 한번씩 Summary 완료 되었나 확인
                  const summaryTimeout = setTimeout(() => {
                    dispatch('getSummaryInfo', false)
                  }, 5000)

                  commit('setSummaryTimeout', summaryTimeout)
                }
                break

              /**
               * Summary Regenerate 호출 결과 처리
               */
              case 'regenerate':
                if (
                  store.getters.currentClip &&
                  parsedData['body'] &&
                  store.getters.currentClip['clipId'] === parsedData['clipId']
                ) {
                  commit('setSummaryInfo', parsedData['body'])
                }
                // let summaryResult = parsedData['body']
                // summaryResult = typeof summaryResult === 'string' ? JSON.parse(summaryResult) : summaryResult

                break
              /**
               * Translate 호출 결과 처리
               */
              case 'translateTranscript':
                if (
                  store.getters.currentClip &&
                  parsedData['body'] &&
                  store.getters.currentClip['clipId'] === parsedData['clipId']
                ) {
                  commit('setTranscriptInfo', parsedData['body'])
                }
                break
              case 'translateSummary':
                if (
                  store.getters.currentClip &&
                  parsedData['body'] &&
                  store.getters.currentClip['clipId'] === parsedData['clipId']
                ) {
                  commit('setSummaryInfo', parsedData['body'])
                }
                break

              default:
                break
            }
          }
        }
      }

      websocket.onclose = () => {
        // console.log('Socket is closed. Reconnect will be attempted in 1 second.', e.reason)
        setTimeout(() => {
          dispatch('connectWebsocket')
        }, 1000)
      }

      // 메세지 전송 전 CLOSED 된 상태에서 재연결을 했으면 메세지 호출을 다시 해준다.
      if (message) {
        dispatch('sendMessage', message)
      }
    },
    /**
     * Websocket 해제
     */
    disConnectWebsocket({ state, commit }) {
      if (state.websocket) {
        state.websocket.close()
        commit('setWebsocket', null)
      }
    },

    /**
     * Websocket 호출
     */
    sendMessage({ state, dispatch }, message) {
      const SOCKET_OPEN = 1
      const SOCKET_CLOSE = 3

      if (state.websocket) {
        // socket 이 열려있는 경우
        if (state.websocket.readyState === SOCKET_OPEN) {
          let payload = {
            action: 'message',
            message,
          }
          state.websocket.send(JSON.stringify(payload))
        }
        // socket 이 닫혀있는 경우
        else if (state.websocket.readyState === SOCKET_CLOSE) {
          dispatch('connectWebsocket', message)
        }
        // else if (state.websocket.readyState === 0) {
        //   setTimeout(() => {
        //     dispatch('connectWebsocket', message)
        //   }, 1000)
        // }
      }
    },
    /**
     * Transcript 정보 호출
     * @param {*} isFirstCall mount 시 처음 호출할때 (재호출은 false)
     * @returns 호출 성공 여부
     */
    getTranscriptInfo({ state, dispatch }, isFirstCall) {
      let result

      // 업로드 요청한지 한시간이 지나지 않은 Transcript 만 재호출
      const anHour = 60 * 60 * 1000
      // const anHour = 300000 * 60 * 1000

      const isTargetClip = state.baseTimeStamp <= store.getters.currentClip['clipUploadedAt']
      const isOverTime = !isFirstCall && Date.now() - store.getters.currentClip['clipUploadedAt'] > anHour

      // 5월1일 이후 업로드 되었고, 업로드한지 한시간이 지나지 않았으면 호출
      if (isTargetClip && !isOverTime) {
        dispatch('sendMessage', {
          type: 'transcript',
          data: {
            clipId: store.getters.currentClip['clipId'],
          },
        })
        result = 'success'
      } else if (!isTargetClip) {
        result = 'nonTarget'
      } else if (!isTargetClip) {
        result = 'overTime'
      } else {
        result = 'fail'
      }
      return result
    },

    /**
     * Summary 정보 호출
     * @param {*} isFirstCall mount 시 처음 호출할때 (재호출은 false)
     * @returns 호출 성공 여부
     */
    getSummaryInfo({ state, dispatch }, isFirstCall) {
      let result

      // 업로드 요청한지 한시간이 지나지 않은 Transcript 만 재호출
      const anHour = 60 * 60 * 1000
      // const anHour = 300000 * 60 * 1000

      const isTargetClip = state.baseTimeStamp <= store.getters.currentClip['clipUploadedAt']
      const isOverTime = !isFirstCall && Date.now() - store.getters.currentClip['clipUploadedAt'] > anHour

      // 5월1일 이후 업로드 되었고, 업로드한지 한시간이 지나지 않았으면 호출
      if (isTargetClip && !isOverTime) {
        dispatch('sendMessage', {
          type: 'summary',
          data: {
            clipId: store.getters.currentClip['clipId'],
          },
        })
        result = 'success'
      } else if (!isTargetClip) {
        result = 'nonTarget'
      } else if (!isTargetClip) {
        result = 'overTime'
      } else {
        result = 'fail'
      }
      return result
    },

    setRegenerateSummary({ dispatch }, data) {
      dispatch('sendMessage', {
        type: 'regenerate',
        data: data,
      })
    },

    setTranslateTranscript({ dispatch }, data) {
      dispatch('sendMessage', {
        type: 'translateTranscript',
        data: data,
      })
    },

    setTranslateSummary({ dispatch }, data) {
      dispatch('sendMessage', {
        type: 'translateSummary',
        data: data,
      })
    },
  },
  getters: {
    // 웹소켓
    websocket(state) {
      return state.websocket
    },
    transcriptInfo(state) {
      return state.transcriptInfo
    },
    summaryInfo(state) {
      return state.summaryInfo
    },
    transcriptTimeout(state) {
      return state.transcriptTimeout
    },
    summaryTimeout(state) {
      return state.summaryTimeout
    },
    baseTimeStamp(state) {
      return state.baseTimeStamp
    },
    parsingDataList(state) {
      return state.parsingDataList
    },
  },
}

export default service
